/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Subheading.style';

import { createBaseUiComponentProps } from 'src/shared/ui/base/util/uiUtils';

import type { BaseUiComponent } from 'src/shared/ui/base/type/uiTypes';

type Props = {
  ...BaseUiComponent,
  withError?: boolean,
  withWarning?: boolean,
  children: React.Node,
};

const useStyles = createUseThemeStyles(styles);

const Subheading = (props: Props): React.Node => {
  const { as, withError, withWarning, children } = props;

  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();

  const rootClasses = classNames(classes.root, {
    [classes['root-withError']]: withError,
    [classes['root-withWarning']]: withWarning,
  });

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return React.createElement(
    as || 'h2',
    { ...createBaseUiComponentProps(props, rootClasses) },
    children,
  );
};

export default React.memo<Props>(Subheading);
